import { Component,Input,ViewChild } from '@angular/core';
import { ChartData } from '@app/models/dashboard/dynamicDashboard';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';

@Component({
  selector: 'list-control',
  templateUrl: './list.component.html'
})
export class DynamicListComponent {
 

 constructor(){ 
   
 }
 
  @ViewChild("baseChart") chart: BaseChartDirective; 
  @Input() DataListItem: Array<ChartData>;  
  @Input() itemPerPage : number;
  @Input() HeaderListItem : Array<string>
  
  tempCount: number;
  pageNumber: number = 1;
  completeList : Array<any>; 
  filteredList : Array<any>;
  pageControl(event: number, sortName: string) {
    this.pageNumber = event;
    if(!(this.itemPerPage != null && this.itemPerPage > 0))
    {
      this.itemPerPage = 5; //default value
    }
    this.bindPaginationData(this.itemPerPage * (this.pageNumber - 1));
  }
  bindPaginationData(offset: number) {
    // debugger;
    this.filteredList = this.completeList.slice(offset,(offset + this.itemPerPage));
  }
  ngOnInit()
  {
    if(!(this.itemPerPage != null && this.itemPerPage > 0))
    {
      this.itemPerPage = 5; //default value
    }
    this.completeList = this.DataListItem;
    this.tempCount = this.completeList.length;

    if(length > 0 && length > this.itemPerPage)
    {
      this.filteredList = this.completeList.slice(0,this.itemPerPage);
    }
    else
    {
      this.filteredList = this.completeList;
    }
 }

  showRecords(itemPerPage) {
    this.itemPerPage = itemPerPage;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/common/list.component.ts